// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Checkbox Mixins.
 */
@keyframes check {
  0% {
    height: 0;
    left: 0;
    top: 8px;
    width: 0;
  }
  50% {
    height: 0;
    left: 0;
    top: 8px;
    width: 4px;
  }
  100% {
    height: 10px;
    left: 4px;
    top: 0;
    width: 4px;
  }
}
@keyframes checkindeterminate {
  0% {
    width: 0;
  }
  100% {
    width: 10px;
  }
}
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host([label-position=inline-start]) .ids-input,
:host([label-position=inline-start]) .ids-textarea {
  display: flex;
  align-items: var(--ids-label-align-y, center);
  gap: 8px;
}
:host([label-position=inline-start]) .ids-input label,
:host([label-position=inline-start]) .ids-textarea label {
  width: var(--ids-label-width);
  padding-block: var(--ids-label-padding-block);
  padding-inline-end: 0;
  box-sizing: border-box;
  flex-shrink: 0;
}
:host([label-position=inline-start]) .ids-input .validation-message,
:host([label-position=inline-start]) .ids-textarea .validation-message {
  width: 100%;
  margin-block-start: var(--ids-space-2xs);
}
@media (max-width: 927px) {
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    margin-inline-start: 0;
  }
}
:host([label-position=inline-start]) .ids-input + .validation-message,
:host([label-position=inline-start]) .ids-textarea + .validation-message {
  min-width: min-content;
  margin-block-start: calc(0px - var(--ids-space-2xs));
  margin-inline-start: calc(var(--ids-label-width) + 6px);
}
:host([label-position=inline-start]) .ids-input.xs + .validation-message,
:host([label-position=inline-start]) .ids-textarea.xs + .validation-message {
  position: relative;
  inset-inline-start: 6px;
  margin-inline-start: calc(var(--ids-label-width));
}
:host([label-position=inline-start]) .ids-input .ids-label-text,
:host([label-position=inline-start]) .ids-textarea .ids-label-text {
  margin-bottom: unset;
}
@media (width > 320px) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@container (width > \$breakpoint-xs) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@media (min-width: 767px) {
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label {
    flex: 0 0 auto;
    margin-bottom: unset;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-input .field-container,
  :host([label-position=inline-start]) .ids-textarea .field-container {
    order: 2;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    flex: 1 1 100%;
    min-width: 100%;
    order: 3;
    margin-block-start: calc(0px - var(--ids-space-2xs));
  }
  :host([label-position=inline-start]) .ids-input.wrapped .validation-message,
  :host([label-position=inline-start]) .ids-textarea.wrapped .validation-message {
    margin-block-start: calc(0px - var(--ids-space-2xs));
    margin-inline-start: calc(var(--ids-label-width) + 6px);
  }
}
:host([label-position=inline-start]) .ids-checkbox {
  container-type: inline-size;
  margin-top: var(--ids-space-00);
}
@container (width >= 200px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: 0;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + 0.4rem);
    margin-block-start: 3px;
  }
  :host([label-position=inline-start]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    left: unset;
    inset-inline-end: -1.5rem;
  }
  :host([label-position=inline-start]) .ids-checkbox label.required .label-checkbox::after {
    right: 30px;
  }
}

:host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
  container-type: normal;
}
@media (width <= 320px) {
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: 0;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + 0.4rem);
    margin-block-start: 3px;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    left: unset;
    inset-inline-end: -1.5rem;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label.required .label-checkbox::after {
    right: 30px;
  }
}

:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
    justify-content: flex-start;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after {
  margin-inline-end: 0;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea {
    display: block;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea {
    display: block;
  }
}
:host([label-position=inline-start][label-alignment=end]) .field-container {
  flex: 1;
}

:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea {
  display: flex;
  flex-wrap: nowrap;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea label {
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input:not(.xs),
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input:not(.xs) {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  display: grid;
  gap: 0;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: var(--ids-space-2, 0.5rem);
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea label {
  grid-column: 1;
  grid-row: 1;
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .field-container {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .validation-message {
  grid-column: 1/-1;
  grid-row: 2;
  width: auto;
  margin-inline-start: 0;
  margin-block-start: var(--ids-space-2xs);
}
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.wrapped .validation-message {
  grid-column: 2;
  margin-inline-start: 0;
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    display: block;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    flex-wrap: wrap;
  }
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}

:host([label-position=inline-start][label-break=break]) .ids-input,
:host([label-position=inline-start][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-start][label-break=break]) .ids-input label,
:host([label-position=inline-start][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=break]) .ids-input .field-container,
:host([label-position=inline-start][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=break]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host([label-position=inline-start][label-width="0px"]) .ids-label-text,
:host([label-position=inline-start][label-width="0"]) .ids-label-text {
  display: none;
}

:host([label-position=inline-end][label-break=shrink-value]) .ids-input,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea {
  display: flex;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input label,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea label {
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input .field-container,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

@media (width > 320px) {
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    justify-content: end;
    flex: 0 1 auto;
    order: 2;
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    order: 1;
  }
}

:host([label-position=inline-end][label-break=break]) .ids-input,
:host([label-position=inline-end][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-end][label-break=break]) .ids-input label,
:host([label-position=inline-end][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=break]) .ids-input .field-container,
:host([label-position=inline-end][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-end][label-break=break]) .ids-textarea .validation-message {
  margin-inline-start: 0;
  order: 3;
}
:host([label-position=inline-end][label-break=break]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start]) {
  --ids-label-width: var(--ids-label-width-inline-start);
}

:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea label {
  align-self: var(--ids-label-align-y, center);
}
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea .ids-label-text {
  overflow: visible;
}

@media (width > 767px) {
  :host([label-position=inline-start]) .ids-textarea {
    max-width: calc(370px + var(--ids-label-width));
  }
  :host([label-position=inline-start]) .ids-textarea .textarea-field {
    width: calc(370px + var(--ids-label-width));
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-filter-field label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-filter-field #operator-button {
    position: relative;
    inset-inline-start: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    width: 100%;
    margin-block-start: var(--ids-space-2xs);
  }
}
@media (width < 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: inherit;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-inline-start: initial;
  }
}

@media (min-width: 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    right: initial;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-block-start: 0;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-radio-group,
  :host([label-position=inline-end]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-start]) .ids-radio-group ids-text.group-label-text,
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-radio-group slot,
  :host([label-position=inline-end]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
  }
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    justify-content: end;
    order: 2;
  }
  :host([label-position=inline-end]) .ids-radio-group slot {
    order: 1;
  }
}
@media (width < 767px) {
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
    flex-direction: column;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
    order: 2;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    order: 1;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-switch {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-switch label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    padding-inline-start: 0;
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-switch input[type=checkbox] ~ .slider {
    left: unset;
    right: -45px;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-switch input[type=checkbox] ~ .slider {
    left: 45px;
    right: initial;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-data-label {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-data-label .label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    margin-block-end: 0;
    white-space: nowrap;
  }
  :host([label-position=inline-start]) .ids-data-label .data,
  :host([label-position=inline-start]) .ids-data-label .description {
    display: flex;
    padding-block: var(--ids-label-padding-block);
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: block;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: block;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
:host .ids-input label,
:host .ids-input .label,
:host .ids-textarea label,
:host .ids-textarea .label,
:host .ids-checkbox label,
:host .ids-checkbox .label,
:host .ids-radio label,
:host .ids-radio .label,
:host .ids-switch label,
:host .ids-switch .label,
:host .ids-data-label label,
:host .ids-data-label .label,
:host .ids-filter-field label,
:host .ids-filter-field .label {
  width: var(--ids-label-width);
}

:host([hidden]) {
  display: none;
}

:host(.justify-center) .ids-checkbox .checkmark,
:host(.justify-center) .ids-checkbox:not([color]) input[type=checkbox] ~ .checkmark {
  top: calc(50% - 8px);
}

:host([no-margins]) .ids-checkbox,
:host([no-margin]) .ids-checkbox {
  margin: var(--ids-space-none);
}
:host([no-margins]) .ids-checkbox label.empty,
:host([no-margin]) .ids-checkbox label.empty {
  position: relative;
  top: 4px;
}

:host(.event-type-checkbox) .ids-checkbox .ids-label-text {
  max-width: 150px;
}

.ids-checkbox {
  margin-bottom: var(--ids-space-xs);
  margin-top: var(--ids-checkbox-margin-top);
}
.ids-checkbox label {
  cursor: var(--ids-cursor-pointer);
  user-select: none;
  padding-inline-start: var(--ids-checkbox-padding-inline-start);
  margin-inline-end: var(--ids-checkbox-margin-inline-end);
  position: relative;
  inset-inline-start: 0;
  display: block;
}
.ids-checkbox label.empty::before {
  content: " ";
}
.ids-checkbox label.required .label-checkbox span::after {
  position: absolute;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-md);
  color: var(--ids-input-required-indicator-color-text-default);
  content: "*";
  margin-top: -5px;
  margin-inline-start: 1px;
}
.ids-checkbox label.no-required-indicator .label-checkbox span::after, .ids-checkbox label.empty .label-checkbox span::after {
  content: "";
}
.ids-checkbox .label-checkbox {
  position: relative;
  top: var(--ids-checkbox-label-top, 1px);
}
.ids-checkbox .label-checkbox span {
  white-space: normal;
}
.ids-checkbox.label-align-start {
  text-align: start;
}
.ids-checkbox.label-align-end {
  text-align: end;
}
.ids-checkbox.label-align-center {
  text-align: center;
}
.ids-checkbox.label-align-justify {
  text-align: justify;
}
.ids-checkbox.disabled label {
  cursor: var(--ids-cursor-default);
  opacity: var(--ids-checkbox-opacity-disabled);
}
.ids-checkbox.disabled label.required .label-checkbox span::after {
  color: var(--ids-input-required-indicator-color-text-disabled);
}
.ids-checkbox.hitbox {
  padding-top: var(--ids-space-12);
  padding-bottom: var(--ids-space-12);
}
.ids-checkbox.hitbox label {
  padding-inline-start: 42px;
}
.ids-checkbox.hitbox label span.checkmark {
  margin-inline-start: 14px;
}
.ids-checkbox.hitbox .validation-message {
  margin-inline-start: 14px;
}
.ids-checkbox.horizontal {
  margin-inline-end: var(--ids-space-12);
  display: inline-block;
}
.ids-checkbox input[type=checkbox] {
  position: absolute;
  cursor: var(--ids-cursor-pointer);
  opacity: 0;
  height: 0;
  width: 0;
}
.ids-checkbox input[type=checkbox] ~ .checkmark {
  position: absolute;
  border: var(--ids-checkbox-border);
  border-radius: var(--ids-checkbox-border-radius);
  height: 14px;
  width: 14px;
  left: 0;
  top: 3px;
}
.ids-checkbox input[type=checkbox].error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-error);
}
.ids-checkbox input[type=checkbox]:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected);
  border-color: var(--ids-checkbox-color-border-selected);
}
.ids-checkbox input[type=checkbox]:checked ~ .checkmark::after {
  position: absolute;
  display: block;
  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);
  border-width: var(--ids-checkbox-border-width-selected-after);
  animation: check 0.15s ease-out;
  transform: rotate(45deg);
  content: "";
  height: 10px;
  left: 4px;
  top: 0;
  width: 4px;
}
.ids-checkbox input[type=checkbox].indeterminate ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-indeterminate);
  border-color: var(--ids-checkbox-color-border-indeterminate);
}
.ids-checkbox input[type=checkbox].indeterminate ~ .checkmark::after {
  position: absolute;
  animation: checkindeterminate 0.15s ease-out;
  display: block;
  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);
  border-width: var(--ids-checkbox-border-width-indeterminate);
  content: "";
  height: 6px;
  left: 2px;
  top: 0;
  transform: none;
  width: 10px;
}
.ids-checkbox input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus);
  box-shadow: var(--ids-checkbox-shadow-focus);
}
.ids-checkbox input[type=checkbox]:focus.error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus-error);
  box-shadow: var(--ids-checkbox-shadow-focus-error);
}
.ids-checkbox input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox input[type=checkbox]:disabled ~ .label-checkbox {
  cursor: var(--ids-cursor-default);
  color: var(--ids-checkbox-color-text-disabled);
}
.ids-checkbox input[type=checkbox]:disabled.error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus-error);
}
.ids-checkbox input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox.no-animation input[type=checkbox]:checked ~ .checkmark::after {
  animation: none;
}
.ids-checkbox[color=green] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-green-70);
  border-color: var(--ids-color-green-70);
}
.ids-checkbox[color=green] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=green] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=green] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-green-70);
}
.ids-checkbox[color=purple] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-purple-70);
  border-color: var(--ids-color-purple-70);
}
.ids-checkbox[color=purple] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=purple] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=purple] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-purple-70);
}
.ids-checkbox[color=blue] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-blue-70);
  border-color: var(--ids-color-blue-70);
}
.ids-checkbox[color=blue] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=blue] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=blue] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-blue-70);
}
.ids-checkbox[color=orange] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-orange-70);
  border-color: var(--ids-color-orange-70);
}
.ids-checkbox[color=orange] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=orange] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=orange] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-orange-70);
}
.ids-checkbox[color=red] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-red-70);
  border-color: var(--ids-color-red-70);
}
.ids-checkbox[color=red] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=red] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=red] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-red-70);
}
.ids-checkbox .validation-message {
  margin-top: var(--ids-space-2xs);
  margin-inline-start: -1px;
}
.ids-checkbox.has-focus input[type=checkbox] ~ .checkmark {
  border-color: var(--ids-checkbox-focus-border-color);
  box-shadow: var(--ids-checkbox-focus-box-shadow);
}

:host([dir=rtl]) input[type=checkbox] ~ .checkmark {
  left: initial;
  right: 0;
}

:host(.multiselect-checkbox.ellipsis) .ids-checkbox label {
  padding-inline-start: var(--ids-space-sm);
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
  display: flex;
}
:host(.multiselect-checkbox.ellipsis) .ids-checkbox label .label-checkbox span {
  white-space: unset;
}
:host(.multiselect-checkbox.ellipsis) .ids-checkbox label ids-text::part(text),
:host(.multiselect-checkbox.ellipsis) .ids-checkbox label .ids-text {
  display: unset;
  position: relative;
  top: -1px;
}

:host(.multiselect-checkbox.ellipsis[size=full]) .ids-checkbox label {
  display: flex;
  max-width: 100%;
}
:host(.multiselect-checkbox.ellipsis[size=full]) .ids-checkbox label .label-checkbox span {
  white-space: nowrap;
}

:host(.multiselect-loaded) .ids-checkbox {
  text-indent: 0;
  position: relative;
  top: -5px;
}
:host(.multiselect-loaded) .ids-checkbox label {
  margin-inline-end: 0;
  padding-inline-start: var(--ids-space-sm);
}

:host(.multiselect-checkbox) input[type=checkbox]:not(:checked):not(:disabled) ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-multiselect);
  top: 2px;
}
:host(.multiselect-checkbox) {
  margin-top: auto;
  margin-bottom: auto;
}
:host(.multiselect-checkbox) .ids-checkbox ids-text {
  top: 2px;
}
:host(.multiselect-checkbox) .ids-checkbox ids-text:not(.empty) {
  inset-inline-start: 4px;
}

:host([label-wrap=ellipsis]) .ids-checkbox .label-checkbox {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host([label-wrap=ellipsis]) .ids-checkbox .label-checkbox span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=ellipsis-no-stretch]) .ids-checkbox .label-checkbox {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host([label-wrap=ellipsis-no-stretch]) .ids-checkbox .label-checkbox span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host([label-wrap=ellipsis-no-stretch]) .ids-checkbox .label-checkbox {
  max-width: 75%;
}

:host([label-wrap=wrap-no-stretch]) .ids-checkbox .label-checkbox {
  max-width: 75%;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-checkbox/ids-checkbox.scss","webpack://./src/themes/mixins/ids-checkbox-mixin.scss","webpack://./src/themes/mixins/ids-validation-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss","webpack://./src/themes/mixins/ids-label-position-mixin.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAoIA;EACE;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,QAAA;ED/HF;ECkIA;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,UAAA;EDhIF;ECmIA;IACE,YAAA;IACA,SAAA;IACA,MAAA;IACA,UAAA;EDjIF;AACF;ACoIA;EACE;IACE,QAAA;EDlIF;ECqIA;IACE,WAAA;EDnIF;AACF;AE7BA;ECQE,mCAAA;EACA,kCAAA;EDNA,aAAA;EACA,+EAAA;EACA,gCAAA;EACA,sCAAA;AF+BF;AE7BE;EACE,oCAAA;AF+BJ;AE5BE;EACE,2CAAA;AF8BJ;AE3BE;EACE,uCAAA;AF6BJ;AE1BE;EACE,uCAAA;AF4BJ;AE1BI;EACE,iCAAA;AF4BN;AExBE;EACE,uCAAA;AF0BJ;AExBI;EACE,iCAAA;AF0BN;AEtBE;EACE,qCAAA;AFwBJ;AEtBI;EACE,8BAAA;AFwBN;AEpBE;EACE,oCAAA;AFsBJ;AEpBI;EACE,+BAAA;AFsBN;AElBE;EACE,uCAAA;AFoBJ;AElBI;EACE,gCAAA;AFoBN;AEhBE;EACE,aAAA;AFkBJ;;AI5EE;;EAEE,aAAA;EACA,6CAAA;EACA,QAAA;AJ+EJ;AI5EI;;EACE,6BAAA;EACA,6CAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;AJ+EN;AI3EI;;EACE,WAAA;EACA,wCAAA;AJ8EN;AI5EM;EAJF;;IAKI,sBAAA;EJgFN;AACF;AI7EI;;EACE,sBAAA;EACA,oDAAA;EACA,uDAAA;AJgFN;AI7EI;;EACE,kBAAA;EACA,uBAAA;EACA,iDAAA;AJgFN;AI7EI;;EACE,oBAAA;AJgFN;AI9EM;EAHF;;IAII,oBAAA;EJkFN;AACF;AIhFM;EAPF;;IAQI,oBAAA;EJoFN;AACF;AIjFI;EACE;;IACE,cAAA;IACA,oBAAA;IACA,QAAA;EJoFN;EIjFI;;IACE,QAAA;EJoFN;EIjFI;;IACE,cAAA;IACA,eAAA;IACA,QAAA;IACA,oDAAA;EJoFN;EIhFM;;IACE,oDAAA;IACA,uDAAA;EJmFR;AACF;AI7EE;EACE,2BAAA;EACA,+BAAA;AJ+EJ;AI7EI;EAJF;IAKI,aAAA;IACA,eAAA;IACA,+CAAA;EJgFJ;EI7EI;IACE,sCAAA;IAEA,6CAAA;IACA,uDAAA;IACA,sBAAA;EJ8EN;EI3EI;IACE,OAAA;EJ6EN;EI1EI;IACE,WAAA;IACA,0DAAA;IACA,uBAAA;EJ4EN;EIzEI;IACE,WAAA;IACA,yBAAA;EJ2EN;EIxEI;IACE,WAAA;EJ0EN;AACF;;AInEE;EACE,sBAAA;AJsEJ;AIpEI;EAHF;IAII,aAAA;IACA,eAAA;IACA,+CAAA;EJuEJ;EIrEI;IACE,sCAAA;IAEA,6CAAA;IACA,uDAAA;IACA,sBAAA;EJsEN;EInEI;IACE,OAAA;EJqEN;EIlEI;IACE,WAAA;IACA,0DAAA;IACA,uBAAA;EJoEN;EIjEI;IACE,WAAA;IACA,yBAAA;EJmEN;EIhEI;IACE,WAAA;EJkEN;AACF;;AI1DI;;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AJ8DN;AI5DM;EALF;;IAMI,2BAAA;EJgEN;AACF;AI9DM;EATF;;IAUI,2BAAA;EJkEN;AACF;AI/DQ;;EACE,oBAAA;AJkEV;AI7DI;EAtBF;;IAuBI,cAAA;EJiEJ;AACF;AI/DI;EA1BF;;IA2BI,cAAA;EJmEJ;AACF;AIhEE;EACE,OAAA;AJkEJ;;AI3DE;;;;EAEE,aAAA;EACA,iBAAA;AJgEJ;AI9DI;;;;EACE,cAAA;AJmEN;AIhEI;;;;EACE,YAAA;EACA,cAAA;AJqEN;AIjEI;;;;EACE,WAAA;EACA,sBAAA;AJsEN;AIlEE;;EACE,+BAAA;AJqEJ;;AI/DE;;EAEE,aAAA;EACA,MAAA;EACA,0CAAA;EACA,sCAAA;AJkEJ;AIhEI;;EACE,cAAA;EACA,WAAA;AJmEN;AIhEI;;EACE,cAAA;EACA,WAAA;EACA,YAAA;AJmEN;AIhEI;;EACE,iBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,wCAAA;AJmEN;AIhEI;;EACE,cAAA;EACA,sBAAA;AJmEN;;AI7DE;EACE;IACE,aAAA;IACA,+CAAA;EJgEJ;EI9DI;IACE,6BAAA;IACA,cAAA;EJgEN;EI7DI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EJ+DN;AACF;AI3DE;EACE;;IAEE,cAAA;EJ6DJ;AACF;AI1DE;EACE;;IAEE,eAAA;EJ4DJ;AACF;;AIvDE;EACE;IACE,aAAA;IACA,+CAAA;EJ0DJ;EIxDI;IACE,6BAAA;IACA,cAAA;EJ0DN;EIvDI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EJyDN;AACF;;AInDE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;AJsDJ;AIpDI;;EACE,WAAA;EACA,cAAA;AJuDN;AIpDI;;EACE,YAAA;EACA,cAAA;AJuDN;AInDI;;EACE,WAAA;EACA,sBAAA;AJsDN;;AI9CE;;EACE,aAAA;AJkDJ;;AI3CE;;EAEE,aAAA;AJ8CJ;AI5CI;;EACE,cAAA;EACA,QAAA;AJ+CN;AI5CI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;AJ+CN;AI3CE;EACE,+BAAA;AJ6CJ;;AIxCE;EACE;IACE,aAAA;IACA,+CAAA;EJ2CJ;EIzCI;IACE,6BAAA;IACA,oBAAA;IACA,cAAA;IACA,QAAA;EJ2CN;EIxCI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;IACA,QAAA;EJ0CN;AACF;;AIpCE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;AJuCJ;AIrCI;;EACE,WAAA;EACA,cAAA;EACA,QAAA;AJwCN;AIrCI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;AJwCN;AIpCI;;EACE,sBAAA;EACA,QAAA;AJuCN;AInCE;EACE,+BAAA;AJqCJ;;AIjCA;EACE,sDAAA;AJoCF;;AI3BI;;;;EACE,4CAAA;AJiCN;AI9BI;;;;EACE,iBAAA;AJmCN;;AI7BA;EAEI;IACE,+CAAA;EJ+BJ;EI7BI;IACE,2CAAA;EJ+BN;AACF;AIzBA;EAEI;IACE,aAAA;IACA,eAAA;IACA,+CAAA;EJ0BJ;EIxBI;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,sBAAA;EJ0BN;EItBI;IACE,kBAAA;IACA,0CAAA;EJwBN;EIpBI;IACE,WAAA;IACA,wCAAA;EJsBN;AACF;AIfE;EAEI;IACE,4CAAA;EJgBN;EIbI;IACE,4BAAA;EJeN;AACF;;AIVA;EAEI;IACE,cAAA;EJYJ;EITE;IACE,qBAAA;EJWJ;AACF;AILA;EAGI;;IACE,aAAA;IACA,+CAAA;IACA,+BAAA;EJMJ;EIJI;;IACE,iCAAA;EJON;EIJI;;IACE,aAAA;IACA,sBAAA;EJON;EIDE;IACE,oBAAA;IACA,QAAA;EJGJ;EIAE;IACE,QAAA;EJEJ;AACF;AIGA;EAEI;IACE,aAAA;IACA,+CAAA;IACA,+BAAA;IACA,sBAAA;EJFJ;EIII;IACE,iCAAA;IACA,QAAA;EJFN;EIKI;IACE,aAAA;IACA,sBAAA;IACA,QAAA;EJHN;AACF;AISA;EACE;IACE,aAAA;IACA,eAAA;IACA,+CAAA;EJPF;EISE;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,uBAAA;IACA,sBAAA;EJPJ;EIUE;IACE,WAAA;IACA,YAAA;EJRJ;EIaE;IACE,UAAA;IACA,cAAA;EJXJ;AACF;AIgBA;EACE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,+CAAA;EJdF;EIgBE;IACE,6BAAA;IACA,6CAAA;IACA,sBAAA;IACA,mBAAA;IACA,mBAAA;EJdJ;EIiBE;;IAEE,aAAA;IACA,6CAAA;EJfJ;AACF;AIoBA;EAEI;;;IAGE,cAAA;IACA,sBAAA;IACA,kBAAA;EJnBJ;EIqBI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;EJjBN;EIoBI;;;IACE,sBAAA;EJhBN;EIsBE;;;IAGE,cAAA;IACA,sBAAA;IACA,kBAAA;IACA,+BAAA;EJpBJ;EIsBI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;EJlBN;EIqBI;;;IACE,sBAAA;EJjBN;AACF;AI+BI;;;;;;;;;;;;;;EAEE,6BAAA;AJjBN;;AAvnBA;EACE,aAAA;AA0nBF;;AAvnBA;;EAEE,oBAAA;AA0nBF;;AAvnBA;;EAEE,6BAAA;AA0nBF;AAxnBE;;EACE,kBAAA;EACA,QAAA;AA2nBJ;;AAtnBE;EACE,gBAAA;AAynBJ;;AArnBA;EACE,kCAAA;EACA,0CAAA;AAwnBF;AAtnBE;EACE,iCAAA;EACA,iBAAA;EACA,8DAAA;EACA,wDAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AAwnBJ;AAtnBI;EACE,YAAA;AAwnBN;AArnBI;EACE,kBAAA;EACA,+EAAA;EACA,kCAAA;EACA,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;AAunBN;AAlnBM;EACE,WAAA;AAonBR;AA/mBE;EACE,kBAAA;EACA,uCAAA;AAinBJ;AA/mBI;EACE,mBAAA;AAinBN;AA3mBI;EACE,iBAAA;AA6mBN;AA1mBI;EACE,eAAA;AA4mBN;AAzmBI;EACE,kBAAA;AA2mBN;AAxmBI;EACE,mBAAA;AA0mBN;AAtmBE;EACE,iCAAA;EACA,6CAAA;AAwmBJ;AAtmBI;EACC,8DAAA;AAwmBL;AApmBE;EACE,gCAAA;EACA,mCAAA;AAsmBJ;AApmBI;EACE,0BAAA;AAsmBN;AApmBM;EACE,yBAAA;AAsmBR;AAlmBI;EACE,yBAAA;AAomBN;AAhmBE;EACE,sCAAA;EACA,qBAAA;AAkmBJ;AA/lBE;EACE,kBAAA;EACA,iCAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;AAimBJ;AA/lBI;ECxJF,kBAAA;EACA,kCAAA;EACA,gDAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;AD0vBF;AApmBI;EClJF,oDAAA;ADyvBF;AAnmBI;ECjJF,+DAAA;EACA,uDAAA;ADuvBF;AApmBM;EC/IJ,kBAAA;EACA,cAAA;EACA,sFAAA;EACA,6DAAA;EACA,+BAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;ADsvBF;AA5mBI;ECrIF,oEAAA;EACA,4DAAA;ADovBF;AA7mBM;ECnIJ,kBAAA;EACA,4CAAA;EACA,cAAA;EACA,sEAAA;EACA,4DAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;EACA,eAAA;EACA,WAAA;ADmvBF;AArnBI;ECpGF,oDAAA;EACA,4CAAA;AD4tBF;AArnBI;ECnGF,0DAAA;EACA,kDAAA;AD2tBF;AApnBM;EClIJ,+DAAA;EACA,uDAAA;EACA,iCAAA;ADyvBF;AArnBM;ECvHJ,iCAAA;EACA,8CAAA;AD+uBF;AArnBM;ECpIJ,0DAAA;AD4vBF;AApnBM;ECpIJ,wEAAA;EACA,gEAAA;AD2vBF;AAjnBI;EACE,eAAA;AAmnBN;ACjuBM;EAoBJ,2CAvBU;EAwBV,uCAxBU;ADwuBZ;ACjuBM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;ADgxBF;ACluBM;EAtCJ,wEAAA;EACA,gEAAA;AD2wBF;ACluBM;EAaJ,uCA5BU;ADovBZ;ACjvBM;EAoBJ,4CAvBU;EAwBV,wCAxBU;ADwvBZ;ACjvBM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;ADgyBF;AClvBM;EAtCJ,wEAAA;EACA,gEAAA;AD2xBF;AClvBM;EAaJ,wCA5BU;ADowBZ;ACjwBM;EAoBJ,0CAvBU;EAwBV,sCAxBU;ADwwBZ;ACjwBM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;ADgzBF;AClwBM;EAtCJ,wEAAA;EACA,gEAAA;AD2yBF;AClwBM;EAaJ,sCA5BU;ADoxBZ;ACjxBM;EAoBJ,4CAvBU;EAwBV,wCAxBU;ADwxBZ;ACjxBM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;ADg0BF;AClxBM;EAtCJ,wEAAA;EACA,gEAAA;AD2zBF;AClxBM;EAaJ,wCA5BU;ADoyBZ;ACjyBM;EAoBJ,yCAvBU;EAwBV,qCAxBU;ADwyBZ;ACjyBM;EA5CJ,+DAAA;EACA,uDAAA;EACA,iCAAA;ADg1BF;AClyBM;EAtCJ,wEAAA;EACA,gEAAA;AD20BF;AClyBM;EAaJ,qCA5BU;ADozBZ;AA5rBE;EACE,gCAAA;EACA,yBAAA;AA8rBJ;AA1rBI;EACE,oDAAA;EACA,gDAAA;AA4rBN;;AArrBE;EACE,aAAA;EACA,QAAA;AAwrBJ;;AAlrBE;EACE,yCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAqrBJ;AAnrBI;EACE,kBAAA;AAqrBN;AAlrBI;;EAEE,cAAA;EACA,kBAAA;EACA,SAAA;AAorBN;;AA9qBE;EACE,aAAA;EACA,eAAA;AAirBJ;AA/qBI;EACE,mBAAA;AAirBN;;AA3qBE;EACE,cAAA;EACA,kBAAA;EACA,SAAA;AA8qBJ;AA5qBI;EACE,oBAAA;EACA,yCAAA;AA8qBN;;AAvqBE;EACE,kEAAA;EACA,QAAA;AA0qBJ;AA7qBA;EAME,gBAAA;EACA,mBAAA;AA0qBF;AAxqBE;EACE,QAAA;AA0qBJ;AAxqBI;EACE,uBAAA;AA0qBN;;AA/8BI;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAk9BN;AAh9BM;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAk9BR;;AA79BI;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAg+BN;AA99BM;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAg+BR;AAv9BI;EACE,cAAA;AAy9BN;;AA19BI;EACE,cAAA;AA69BN","sourcesContent":["@use '../../themes/mixins/ids-checkbox-mixin' as checkbox;\n@use '../../themes/mixins/ids-validation-mixin' as valid;\n@use '../../themes/mixins/ids-label-position-mixin.scss' as label-position;\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Mixin for checkbox label wrap ellipsis\n@mixin ids-checkbox-label-wrap-ellipsis {\n  .ids-checkbox {\n    .label-checkbox {\n      display: block;\n      width: 100%;\n      max-width: 100%;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n\n      span {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n  }\n}\n\n// Mixin for checkbox label wrap no-stretch\n@mixin ids-checkbox-label-wrap-no-stretch {\n  .ids-checkbox {\n    .label-checkbox {\n      max-width: 75%;\n    }\n  }\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n:host(.justify-center) .ids-checkbox .checkmark,\n:host(.justify-center) .ids-checkbox:not([color]) input[type='checkbox'] ~ .checkmark {\n  top: calc(50% - 8px);\n}\n\n:host([no-margins]) .ids-checkbox,\n:host([no-margin]) .ids-checkbox {\n  margin: var(--ids-space-none);\n\n  label.empty {\n    position: relative;\n    top: 4px;\n  }\n}\n\n:host(.event-type-checkbox) .ids-checkbox {\n  .ids-label-text {\n    max-width: 150px;\n  }\n}\n\n.ids-checkbox {\n  margin-bottom: var(--ids-space-xs);\n  margin-top: var(--ids-checkbox-margin-top);\n\n  label {\n    cursor: var(--ids-cursor-pointer);\n    user-select: none;\n    padding-inline-start: var(--ids-checkbox-padding-inline-start);\n    margin-inline-end: var(--ids-checkbox-margin-inline-end);\n    position: relative;\n    inset-inline-start: 0;\n    display: block;\n\n    &.empty::before {\n      content: '\\00a0';\n    }\n\n    &.required .label-checkbox span::after {\n      position: absolute;\n      font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n      font-size: var(--ids-font-size-md);\n      color: var(--ids-input-required-indicator-color-text-default);\n      content: '*';\n      margin-top: -5px;\n      margin-inline-start: 1px;\n    }\n\n    &.no-required-indicator,\n    &.empty {\n      .label-checkbox span::after {\n        content: '';\n      }\n    }\n  }\n\n  .label-checkbox {\n    position: relative;\n    top: var(--ids-checkbox-label-top, 1px);\n\n    span {\n      white-space: normal;\n    }\n  }\n\n  // Label text alignment\n  &.label-align {\n    &-start {\n      text-align: start;\n    }\n\n    &-end {\n      text-align: end;\n    }\n\n    &-center {\n      text-align: center;\n    }\n\n    &-justify {\n      text-align: justify;\n    }\n  }\n\n  &.disabled label {\n    cursor: var(--ids-cursor-default);\n    opacity: var(--ids-checkbox-opacity-disabled);\n\n    &.required .label-checkbox span::after {\n     color: var(--ids-input-required-indicator-color-text-disabled);\n    }\n  }\n\n  &.hitbox {\n    padding-top: var(--ids-space-12);\n    padding-bottom: var(--ids-space-12);\n\n    label {\n      padding-inline-start: 42px;\n\n      span.checkmark {\n        margin-inline-start: 14px;\n      }\n    }\n\n    .validation-message {\n      margin-inline-start: 14px;\n    }\n  }\n\n  &.horizontal {\n    margin-inline-end: var(--ids-space-12);\n    display: inline-block;\n  }\n\n  input[type='checkbox'] {\n    position: absolute;\n    cursor: var(--ids-cursor-pointer);\n    opacity: 0;\n    height: 0;\n    width: 0;\n\n    ~ .checkmark {\n      @include checkbox.checkbox-unchecked();\n    }\n\n    &.error ~ .checkmark {\n      @include checkbox.checkbox-unchecked-error();\n    }\n\n    &:checked ~ .checkmark {\n      @include checkbox.checkbox-checked();\n\n      &::after {\n        @include checkbox.checkbox-checked-after();\n      }\n    }\n\n    &.indeterminate ~ .checkmark {\n      @include checkbox.checkbox-indeterminate();\n\n      &::after {\n        @include checkbox.checkbox-indeterminate-after();\n      }\n    }\n\n    &:focus ~ .checkmark {\n      @include checkbox.checkbox-focus();\n    }\n\n    &:focus.error ~ .checkmark {\n      @include checkbox.checkbox-focus-error();\n    }\n\n    &:disabled {\n      ~ .checkmark {\n        @include checkbox.checkbox-disabled-unchecked();\n      }\n\n      ~ .label-checkbox {\n        @include checkbox.checkbox-disabled-text();\n      }\n\n      &.error ~ .checkmark {\n        @include checkbox.checkbox-disabled-unchecked-error();\n      }\n\n      &:checked ~ .checkmark {\n        @include checkbox.checkbox-disabled-checked();\n      }\n    }\n  }\n\n  &.no-animation {\n    input[type='checkbox']:checked ~ .checkmark::after {\n      animation: none;\n    }\n  }\n\n  // Colored Checkboxes\n  @include checkbox.checkbox-colored();\n\n  .validation-message {\n    margin-top: var(--ids-space-2xs);\n    margin-inline-start: -1px;\n  }\n\n  &.has-focus {\n    input[type='checkbox'] ~ .checkmark {\n      border-color: var(--ids-checkbox-focus-border-color);\n      box-shadow: var(--ids-checkbox-focus-box-shadow);\n    }\n  }\n}\n\n// Negate some rules for RTL\n:host([dir='rtl']) {\n  input[type='checkbox'] ~ .checkmark {\n    left: initial;\n    right: 0;\n  }\n}\n\n\n:host(.multiselect-checkbox.ellipsis) {\n  .ids-checkbox label {\n    padding-inline-start: var(--ids-space-sm);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top;\n    display: flex;\n\n    .label-checkbox span {\n      white-space: unset;\n    }\n\n    ids-text::part(text),\n    .ids-text {\n      display: unset;\n      position: relative;\n      top: -1px;\n    }\n  }\n}\n\n:host(.multiselect-checkbox.ellipsis[size='full']) {\n  .ids-checkbox label {\n    display: flex;\n    max-width: 100%;\n\n    .label-checkbox span {\n      white-space: nowrap;\n    }\n  }\n}\n\n:host(.multiselect-loaded) {\n  .ids-checkbox {\n    text-indent: 0;\n    position: relative;\n    top: -5px;\n\n    label {\n      margin-inline-end: 0;\n      padding-inline-start: var(--ids-space-sm);\n    }\n  }\n}\n\n// Multiselect checkbox\n:host(.multiselect-checkbox) {\n  input[type='checkbox']:not(:checked):not(:disabled) ~ .checkmark {\n    background-color: var(--ids-checkbox-color-background-multiselect);\n    top: 2px;\n  }\n\n  margin-top: auto;\n  margin-bottom: auto;\n\n  .ids-checkbox ids-text {\n    top: 2px;\n\n    &:not(.empty) {\n      inset-inline-start: 4px;\n    }\n  }\n}\n\n:host([label-wrap='ellipsis']) {\n  @include ids-checkbox-label-wrap-ellipsis();\n}\n\n:host([label-wrap='ellipsis-no-stretch']) {\n  @include ids-checkbox-label-wrap-ellipsis();\n  @include ids-checkbox-label-wrap-no-stretch();\n}\n\n:host([label-wrap='wrap-no-stretch']) {\n  @include ids-checkbox-label-wrap-no-stretch();\n}\n","/**\n * Checkbox Mixins.\n */\n@use 'sass:list';\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Unchecked\n@mixin checkbox-unchecked() {\n  position: absolute;\n  border: var(--ids-checkbox-border);\n  border-radius: var(--ids-checkbox-border-radius);\n  height: 14px;\n  width: 14px;\n  left: 0;\n  top: 3px;\n}\n\n@mixin checkbox-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-error);\n}\n\n// Checked\n@mixin checkbox-checked() {\n  background-color: var(--ids-checkbox-color-background-selected);\n  border-color: var(--ids-checkbox-color-border-selected);\n}\n\n@mixin checkbox-checked-after {\n  position: absolute;\n  display: block;\n  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);\n  border-width: var(--ids-checkbox-border-width-selected-after);\n  animation: check 0.15s ease-out;\n  transform: rotate(45deg);\n  content: '';\n  height: 10px;\n  left: 4px;\n  top: 0;\n  width: 4px;\n}\n\n// Indeterminate\n@mixin checkbox-indeterminate() {\n  background-color: var(--ids-checkbox-color-background-indeterminate);\n  border-color: var(--ids-checkbox-color-border-indeterminate);\n}\n\n@mixin checkbox-indeterminate-after {\n  position: absolute;\n  animation: checkindeterminate 0.15s ease-out;\n  display: block;\n  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);\n  border-width: var(--ids-checkbox-border-width-indeterminate);\n  content: '';\n  height: 6px;\n  left: 2px;\n  top: 0;\n  transform: none;\n  width: 10px;\n}\n\n// Disabled\n@mixin checkbox-disabled-unchecked {\n  background-color: var(--ids-checkbox-color-background-disabled);\n  border-color: var(--ids-checkbox-color-border-disabled);\n  cursor: var(--ids-cursor-default);\n}\n\n@mixin checkbox-disabled-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n}\n\n@mixin checkbox-disabled-checked() {\n  background-color: var(--ids-checkbox-color-background-selected-disabled);\n  border-color: var(--ids-checkbox-color-border-selected-disabled);\n}\n\n@mixin checkbox-disabled-text {\n  cursor: var(--ids-cursor-default);\n  color: var(--ids-checkbox-color-text-disabled);\n}\n\n// Focus\n@mixin checkbox-focus {\n  border-color: var(--ids-checkbox-color-border-focus);\n  box-shadow: var(--ids-checkbox-shadow-focus);\n}\n\n@mixin checkbox-focus-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n  box-shadow: var(--ids-checkbox-shadow-focus-error);\n}\n\n// Colored\n$color-names: 'green' 'purple' 'blue' 'orange' 'red';\n$color-vars: --ids-color-green-70 --ids-color-purple-70 --ids-color-blue-70 --ids-color-orange-70 --ids-color-red-70;\n\n@mixin checkbox-colored() {\n  @each $name in $color-names {\n    $i: list.index($color-names, $name);\n    $color: var(#{list.nth($color-vars, $i)});\n\n    &[color='#{$name}'] input[type='checkbox'] {\n      ~ .checkmark {\n        @include checkbox-colored-box($color);\n      }\n\n      &:disabled ~ .checkmark {\n        @include checkbox-disabled-unchecked();\n      }\n\n      &:disabled:checked ~ .checkmark {\n        @include checkbox-disabled-checked();\n      }\n\n      &:focus ~ .checkmark {\n        @include checkbox-colored-box-focus($color);\n      }\n    }\n  }\n}\n\n@mixin checkbox-colored-box($color) {\n  background-color: $color;\n  border-color: $color;\n}\n\n@mixin checkbox-colored-box-focus($color) {\n  border-color: $color;\n}\n\n// Animations\n@keyframes check {\n  0% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 0;\n  }\n\n  50% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 4px;\n  }\n\n  100% {\n    height: 10px;\n    left: 4px;\n    top: 0;\n    width: 4px;\n  }\n}\n\n@keyframes checkindeterminate {\n  0% {\n    width: 0;\n  }\n\n  100% {\n    width: 10px;\n  }\n}\n","@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.validation-message {\n  @include mixins.antialiased();\n\n  display: flex;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  margin-top: var(--ids-space-2xs);\n  max-width: var(--ids-input-width-full);\n\n  &.has-custom-icon {\n    color: var(--ids-icon-color-default);\n  }\n\n  &.disabled {\n    color: var(--ids-input-color-text-disabled);\n  }\n\n  .ids-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  &.alert {\n    color: var(--ids-color-caution-default);\n\n    &.disabled {\n      color: var(--ids-color-yellow-30);\n    }\n  }\n\n  &.warning {\n    color: var(--ids-color-warning-default);\n\n    &.disabled {\n      color: var(--ids-color-orange-30);\n    }\n  }\n\n  &.error {\n    color: var(--ids-color-error-default);\n\n    &.disabled {\n      color: var(--ids-color-red-30);\n    }\n  }\n\n  &.info {\n    color: var(--ids-color-info-default);\n\n    &.disabled {\n      color: var(--ids-color-blue-30);\n    }\n  }\n\n  &.success {\n    color: var(--ids-color-success-default);\n\n    &.disabled {\n      color: var(--ids-color-green-30);\n    }\n  }\n\n  &[hidden] {\n    display: none;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  color: var(--ids-color-text-default);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n","// Label position styles\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Left aligned and Right Aligned Labels\n:host([label-position='inline-start']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    align-items: var(--ids-label-align-y, center);\n    gap: 8px;\n\n    // Adjust the label\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: 0;\n      box-sizing: border-box;\n      flex-shrink: 0;\n    }\n\n    // Validation on the bottom\n    .validation-message {\n      width: 100%;\n      margin-block-start: var(--ids-space-2xs);\n\n      @media (max-width: $breakpoint-md) {\n        margin-inline-start: 0;\n      }\n    }\n\n    + .validation-message {\n      min-width: min-content;\n      margin-block-start: calc(0px - var(--ids-space-2xs));\n      margin-inline-start: calc(var(--ids-label-width) + 6px);\n    }\n\n    &.xs + .validation-message {\n      position: relative;\n      inset-inline-start: 6px;\n      margin-inline-start: calc(var(--ids-label-width));\n    }\n\n    .ids-label-text {\n      margin-bottom: unset;\n\n      @media (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n      }\n\n      @container (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n      }\n    }\n\n    @media (min-width: $breakpoint-sm) {\n      label {\n        flex: 0 0 auto;\n        margin-bottom: unset;\n        order: 1;\n      }\n\n      .field-container {\n        order: 2;\n      }\n\n      .validation-message {\n        flex: 1 1 100%;\n        min-width: 100%;\n        order: 3;\n        margin-block-start: calc(0px - var(--ids-space-2xs));\n      }\n\n      &.wrapped {\n        .validation-message {\n          margin-block-start: calc(0px - var(--ids-space-2xs));\n          margin-inline-start: calc(var(--ids-label-width) + 6px);\n        }\n      }\n    }\n  }\n\n\n  .ids-checkbox {\n    container-type: inline-size;\n    margin-top: var(--ids-space-00);\n\n    @container (width >= 200px) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      // Adjust the label\n      label {\n        --ids-checkbox-padding-inline-start: 0;\n\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + 0.4rem);\n        margin-block-start: 3px;\n      }\n\n      input[type='checkbox'] ~ .checkmark {\n        left: unset;\n        inset-inline-end: -1.5rem;\n      }\n\n      label.required .label-checkbox::after {\n        right: 30px;\n      }\n    }\n  }\n}\n\n// Horizontal aligned: use viewport media query instead of container query\n:host([label-position='inline-start'][horizontal-aligned]) {\n  .ids-checkbox {\n    container-type: normal;\n\n    @media (width <= $breakpoint-xs) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        --ids-checkbox-padding-inline-start: 0;\n\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + 0.4rem);\n        margin-block-start: 3px;\n      }\n\n      input[type='checkbox'] ~ .checkmark {\n        left: unset;\n        inset-inline-end: -1.5rem;\n      }\n\n      label.required .label-checkbox::after {\n        right: 30px;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      display: inline-flex;\n      align-items: center;\n      justify-content: flex-end;\n\n      @container (width < #{$breakpoint-xs}) {\n        justify-content: flex-start;\n      }\n\n      @media (width < $breakpoint-xs) {\n        justify-content: flex-start;\n      }\n\n      &.required {\n        &::after {\n          margin-inline-end: 0;\n        }\n      }\n    }\n\n    @container (width < #{$breakpoint-xs}) {\n      display: block;\n    }\n\n    @media (width < $breakpoint-xs) {\n      display: block;\n    }\n  }\n\n  .field-container {\n    flex: 1;\n  }\n}\n\n// Label break behavior for inline-start position\n:host([label-position='inline-start'][label-break='shrink-value']:not([validation-message-count])),\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count][error-tracker]) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-wrap: nowrap;\n\n    label {\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n\n  .ids-input:not(.xs) {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n// When validation is present with shrink-value, use grid to keep field width stable\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count]:not([error-tracker])) {\n  .ids-input,\n  .ids-textarea {\n    display: grid;\n    gap: 0;\n    grid-template-columns: auto minmax(0, 1fr);\n    column-gap: var(--ids-space-2, 0.5rem);\n\n    label {\n      grid-column: 1;\n      grid-row: 1;\n    }\n\n    .field-container {\n      grid-column: 2;\n      grid-row: 1;\n      min-width: 0;\n    }\n\n    .validation-message {\n      grid-column: 1 / -1;\n      grid-row: 2;\n      width: auto;\n      margin-inline-start: 0;\n      margin-block-start: var(--ids-space-2xs);\n    }\n\n    &.wrapped .validation-message {\n      grid-column: 2;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-value']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  @media (width < $breakpoint-xs) {\n    .ids-input,\n    .ids-textarea {\n      display: block;\n    }\n  }\n\n  @container (width < #{$breakpoint-xs}) {\n    .ids-input,\n    .ids-textarea {\n      flex-wrap: wrap;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex: 0 1 auto;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-width=\"0px\"]),\n:host([label-position='inline-start'][label-width=\"0\"]) {\n  // When a label is \"inline-start\" and `label-width=\"0px\"` simply don't display it\n  .ids-label-text {\n    display: none;\n  }\n}\n\n\n// Label break behavior for inline-end position\n:host([label-position='inline-end'][label-break='shrink-value']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n\n    label {\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position='inline-end'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        justify-content: end;\n        flex: 0 1 auto;\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n        order: 1;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-end'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      margin-inline-start: 0;\n      order: 3;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position=\"inline-start\"]) {\n  --ids-label-width: var(--ids-label-width-inline-start);\n}\n\n// When label-wrap constrains the label size, ensure it stays vertically centered\n// instead of stretching to fill the flex container height\n:host([label-position=\"inline-start\"][label-wrap=\"ellipsis-no-stretch\"]),\n:host([label-position=\"inline-start\"][label-wrap=\"wrap-no-stretch\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      align-self: var(--ids-label-align-y, center);\n    }\n\n    .ids-label-text {\n      overflow: visible;\n    }\n  }\n}\n\n// Text area\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-textarea {\n      max-width: calc(370px + var(--ids-label-width));\n\n      .textarea-field {\n        width: calc(370px + var(--ids-label-width));\n      }\n    }\n  }\n}\n\n// Filter field\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-filter-field {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        width: var(--ids-label-width);\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      // Filter field specific rules\n      #operator-button {\n        position: relative;\n        inset-inline-start: var(--ids-label-width);\n      }\n\n      // Validation on the bottom\n      .validation-message {\n        width: 100%;\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n// Checkboxes\n:host([label-position='inline-start'][dir='rtl']) {\n  @media (width < $breakpoint-sm) {\n    .ids-checkbox {\n      label {\n        --ids-checkbox-padding-inline-start: inherit;\n      }\n\n      .validation-message {\n        margin-inline-start: initial;\n      }\n    }\n  }\n}\n\n@media (min-width: $breakpoint-sm) {\n  :host([label-position='inline-start'][dir='rtl']) .ids-checkbox {\n    input[type='checkbox'] ~ .checkmark {\n      right: initial;\n    }\n\n    .validation-message {\n      margin-block-start: 0;\n    }\n  }\n}\n\n\n// Radio buttons\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']),\n  :host([label-position='inline-end']) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n      gap: var(--ids-space-2, 0.5rem);\n\n      ids-text.group-label-text {\n        min-width: var(--ids-label-width);\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n      }\n    }\n  }\n\n  :host([label-position='inline-end']) .ids-radio-group {\n    ids-text.group-label-text {\n      justify-content: end;\n      order: 2;\n    }\n\n    slot {\n      order: 1;\n    }\n  }\n}\n\n\n@media (width < $breakpoint-sm) {\n  :host([label-position='inline-end']):not([label-break]) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n      gap: var(--ids-space-2, 0.5rem);\n      flex-direction: column;\n\n      ids-text.group-label-text {\n        min-width: var(--ids-label-width);\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        order: 1;\n      }\n    }\n  }\n}\n\n// Switch\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-switch {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: var(--ids-label-align-y, baseline);\n\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: var(--ids-label-padding-inline-end);\n      padding-inline-start: 0;\n      box-sizing: border-box;\n    }\n\n    input[type='checkbox'] ~ .slider {\n      left: unset;\n      right: -45px;\n    }\n  }\n\n  :host([label-position='inline-start'][dir='rtl']) .ids-switch {\n    input[type='checkbox'] ~ .slider {\n      left: 45px;\n      right: initial;\n    }\n  }\n}\n\n// Data Label\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-data-label {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: var(--ids-label-align-y, baseline);\n\n    .label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      box-sizing: border-box;\n      margin-block-end: 0;\n      white-space: nowrap;\n    }\n\n    .data,\n    .description {\n      display: flex;\n      padding-block: var(--ids-label-padding-block);\n    }\n  }\n}\n\n// Responsive behavior\n@media (max-width: $breakpoint-xs) {\n  :host([label-position=\"inline-start\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: block;\n      flex-direction: column;\n      align-items: unset;\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n\n  :host([label-position=\"inline-end\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: block;\n      flex-direction: column;\n      align-items: unset;\n      gap: var(--ids-space-2, 0.5rem);\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n}\n\n// Just the label width\n:host {\n  .ids-input,\n  .ids-textarea,\n  .ids-checkbox,\n  .ids-radio,\n  .ids-switch,\n  .ids-data-label,\n  .ids-filter-field {\n    label,\n    .label {\n      width: var(--ids-label-width);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
